import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

interface ResendOtpResponse {
  status: string;
}

export const resendOtp = async (): Promise<ResendOtpResponse> => {
  const endpoint = ENDPOINT.ResendOtp;

  const response = await apiHelper(endpoint, {
    method: 'POST',
  });

  const resp = await response.json();

  return response ? resp : void 0;
};
